import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ItemSliding } from 'ionic-angular';

import { DatabaseProvider } from '../../providers/database/database';

import { PickupAddPage } from '../pickup-add/pickup-add';
import { PickupItem } from './pickupitem';

@IonicPage()
@Component({
  selector: 'page-pickup',
  templateUrl: 'pickup.html'
})
export class PickupPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,
                public dbProvider: DatabaseProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DeliveryPage');
  }

  addPickup(){
    console.log('addPickup() called...');
    this.navCtrl.push(PickupAddPage, {});
  }

  markAsPaid(slidingItem: ItemSliding, aPickupItem: PickupItem){
    this.dbProvider.markPickupItemAsPaid(aPickupItem);
    slidingItem.close();
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/pickup/pickup.ts